import React, { useState } from "react";
import { RotateCw, Eye } from "lucide-react";
import ChartBRV from "./ChartBRV";

function FinanceiroBRV() {
  const [products] = useState([
    {
      id: "1000",
      code: "URB-2026-01",
      name: "15/04/2026",
      category: "CONCLUÍDO",
      price: 89.90,
      total: 50000.00,
    },
    {
      id: "1001",
      code: "URB-2026-02",
      name: "28/05/2026",
      category: "EM ANDAMENTO",
      price: 75.00,
      total: 30000.00,
    },
    {
      id: "1002",
      code: "URB-2026-03",
      name: "12/06/2026",
      category: "EM ANDAMENTO",
      price: 65.00,
      total: 20000.00,
    },
  ]);

  const formatCurrency = (value) => {
    return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 py-6 text-urb-text">
      {/* Header */}
      <div className="border-b border-urb-border pb-4 mb-6">
        <h2 className="text-2xl font-bold text-white tracking-tight">Financeiro BRV</h2>
        <p className="text-sm text-urb-text-muted mt-1">
          Visão geral corporativa e consolidação da plataforma URBRace.
        </p>
      </div>

      {/* Gráficos Consolidados */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <div className="bg-urb-card border border-urb-border rounded-2xl p-6 shadow-lg">
          <h3 className="text-base font-bold text-white mb-4">Total Bruto</h3>
          <div className="flex justify-center">
            <ChartBRV />
          </div>
        </div>

        <div className="bg-urb-card border border-urb-border rounded-2xl p-6 shadow-lg">
          <h3 className="text-base font-bold text-white mb-4">Total Líquido</h3>
          <div className="flex justify-center">
            <ChartBRV />
          </div>
        </div>
      </div>

      {/* Tabela de Corridas */}
      <div className="bg-urb-card border border-urb-border rounded-2xl p-6 shadow-lg">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-white tracking-tight">Histórico de Eventos</h3>
          <button
            type="button"
            className="p-2 bg-urb-card-light hover:bg-urb-card border border-urb-border hover:border-urb-primary/60 text-slate-300 hover:text-white rounded-xl transition-colors cursor-pointer"
            title="Atualizar"
          >
            <RotateCw className="w-4 h-4" />
          </button>
        </div>

        <div className="overflow-x-auto rounded-xl border border-urb-border/50">
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="border-b border-urb-border bg-urb-card-light/40 text-xs font-semibold text-slate-400 uppercase tracking-wider">
                <th className="py-3 px-4">Corrida</th>
                <th className="py-3 px-4">Data da Corrida</th>
                <th className="py-3 px-4">Status</th>
                <th className="py-3 px-4">Valor Un.</th>
                <th className="py-3 px-4 text-right">Total Arrecadado</th>
                <th className="py-3 px-4 text-center">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-urb-border/30">
              {products.map((row) => (
                <tr key={row.id} className="hover:bg-urb-card-light/30 transition-colors">
                  <td className="py-3.5 px-4 font-semibold text-white">
                    {row.code}
                  </td>
                  <td className="py-3.5 px-4 text-slate-300">
                    {row.name}
                  </td>
                  <td className="py-3.5 px-4">
                    <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-bold ${
                      row.category === "CONCLUÍDO"
                        ? "bg-emerald-500/10 text-emerald-400 border border-emerald-500/20"
                        : "bg-blue-500/10 text-blue-400 border border-blue-500/20"
                    }`}>
                      {row.category}
                    </span>
                  </td>
                  <td className="py-3.5 px-4 text-slate-300">
                    {formatCurrency(row.price)}
                  </td>
                  <td className="py-3.5 px-4 text-right font-bold text-urb-primary">
                    {formatCurrency(row.total)}
                  </td>
                  <td className="py-3.5 px-4 text-center">
                    <button
                      type="button"
                      className="p-1.5 bg-urb-card-light hover:bg-urb-card border border-urb-border hover:border-urb-primary/60 text-slate-300 hover:text-white rounded-lg transition-colors cursor-pointer"
                    >
                      <Eye className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default FinanceiroBRV;